<button
  type="button"
  class="group relative flex w-full cursor-pointer flex-col items-center justify-center gap-4 rounded-xl border-2 p-6 transition-all duration-200 hover:border-primary-6 hover:bg-primary-2 focus:ring-2 focus:ring-primary-8 focus:ring-offset-2 focus:outline-none"
  [class.border-primary-9]="selected()"
  [class.bg-primary-2]="selected()"
  [class.text-primary-12]="selected()"
  [class.border-neutral-6]="!selected()"
  [class.text-neutral-11]="!selected()"
  [class.hover:text-primary-10]="!selected()"
  (click)="onClick()"
>
  <!-- Icon slot -->
  <div
    class="flex items-center justify-center rounded-full p-3 transition-colors duration-200"
    [class.bg-primary-3]="selected()"
    [class.text-primary-9]="selected()"
    [class.bg-neutral-3]="!selected()"
    [class.text-neutral-10]="!selected()"
    [class.group-hover:bg-primary-3]="!selected()"
    [class.group-hover:text-primary-9]="!selected()"
  >
    <ng-content select="[icon]"></ng-content>
  </div>

  <span class="text-center font-medium">{{ label() }}</span>

  <!-- Checkmark absolute -->
  @if (selected()) {
    <div class="absolute top-3 right-3 text-primary-9">
      <mat-icon>check</mat-icon>
    </div>
  }
</button>
